import Request from "./request";

export default Request;